import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-disabled"]

import {
		computed,
		inject
	} from "vue"

	
	const __default__ = { name: 'VDescription' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const fieldDisabled = inject('fieldDisabled', computed(() => false))
	const fieldsetDisabled = inject('fieldsetDisabled', computed(() => false))
	const descriptionDisabled = computed(() => {
		return fieldDisabled.value || fieldsetDisabled.value
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    "data-slot": "description",
    "data-disabled": descriptionDisabled.value ? true : null,
    class: "text-base/6 text-zinc-500 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-zinc-400"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})